import React from 'react';
import { Skeleton, IconButton, IconClose } from 'gatorcomponents';
import * as Styles from './SupportTicketsCta.styles';

const SupportTicketsCta = ({
  label,
  cta,
  loading,
  onClick,
  onClose,
}) => {
  if (loading) {
    return (
      <Skeleton variant="rectangle" width="386px" height="40px" />
    );
  }

  return (
    <Styles.Container data-testid="support-tickets-cta-container">
      <Styles.Wrapper onClick={onClick} data-testid="support-tickets-cta-wrapper">
        <Styles.Dot data-testid="support-tickets-cta-dot" />
        {label && (
          <Styles.Label data-testid="support-tickets-cta-label">
            {label}
          </Styles.Label>
        )}
        <Styles.Cta data-testid="support-tickets-cta-cta">
          {cta}
          <IconButton icon="IconChevron" />
        </Styles.Cta>
      </Styles.Wrapper>
      {onClose && (
        <Styles.CloseButton onClick={onClose} data-testid="support-tickets-cta-close-button">
          <IconClose size="sm2" color="lowDark" />
        </Styles.CloseButton>
      )}
    </Styles.Container>
  );
};

export default SupportTicketsCta;
